export enum IntercomStatus {
  Connecting = 'connecting',
  Connected = 'connected',
  Failed = 'failed',
}

export interface IntercomAvailability {
  isOnCall: boolean
  /** Translation key explaining why a call cannot be started right now. */
  blocker?: string
}
